import axios from 'axios';
import { getAuthHeaders } from './auth';

const API_BASE = '/api';

export interface GapExample {
  question: string;
  at?: string | null;
  domain?: string | null;
}

export interface GapCluster {
  count: number;
  question: string;      // most recent phrasing — the cluster's face
  last_asked?: string | null;
  domains: string[];
  examples: GapExample[];
}

export interface ContentGaps {
  window_days: number;
  total_messages: number;
  unanswered_count: number;
  unanswered_rate: number;
  clusters: GapCluster[];
}

export const getContentGaps = async (days = 30, domainId?: number): Promise<ContentGaps> => {
  const res = await axios.get(`${API_BASE}/admin/content-gaps`, {
    params: { days, ...(domainId != null ? { domain_id: domainId } : {}) },
    headers: getAuthHeaders(),
  });
  return res.data;
};
